import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../../globals';
import { PendingRequest } from '../modal/pendingrequest';
import { Approved, updateApproved } from '../modal/approved';

@Injectable({
    providedIn: 'root'
})

export class UpdateHcService {
    constructor(private httpclient: HttpClient, private global: Globals) {
    }

   

    GetPendingRequest() {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/emailData/new", { headers: headers });
    }

    GetAllSubject() {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/subject", { headers:headers });
    }

    GetAllSpecification() {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/specification", { headers:headers });
    }

    GetAllRemark() {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/remark", { headers: headers });
    }

    UpdateHealthCard(updateApproved:updateApproved) {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        debugger;
        return this.httpclient.put(this.global.G_apiUrl + "/approvedEmail/"+updateApproved.appEmailId, {
            "appEmailId": updateApproved.appEmailId,
            "senderID": updateApproved.senderID,
            "ccId": updateApproved.ccId,
            "toId": updateApproved.toId,
            "body": updateApproved.body,
            "date_time": updateApproved.date_time,
            "amount": updateApproved.amount,
            "hide": updateApproved.hide,
            "star": updateApproved.star,
            "deleted": false,
            "extra1": "",
            "extra2": "",
            "email_Id": updateApproved.email_Id,
            "user_id": updateApproved.user_id,
            "attachment": updateApproved.attachment,
            "sub": updateApproved.sub,
            "spec": updateApproved.spec,
            "remark": updateApproved.remark
        }, { headers:headers });
    }

    // DeclineRequest(id: any) {
    //     return this.httpclient.put(this.global.G_apiUrl + '/emailData/' + id, {
    //         headers: this.headers
    //     });
    // }
}
